import { OidcRedirectCallback } from '@britishcouncil/react-oidc-auth';
import { DebouncedFullScreenLoader } from 'components';

export const OidcCallback = () => {
  return (
    <OidcRedirectCallback
      redirectTo={'/'}
      errorCallback={(error) => {
        console.error(error);
      }}
    >
      <DebouncedFullScreenLoader />
    </OidcRedirectCallback>
  );
};
